import React, { useState } from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { setPostImage } from '@images/imageUrls';
import { useFeedbackAttachmentActions } from '../FeedbackAttachmentContext';
import styles from './index.module.scss';

const H5FeedbackAttachmentDisplay: React.FC = () => {
    const {
        imageAttachments,
        videoUrl,
        hasVideo,
        canUploadImages,
        canUploadVideo,
        uploadingImages,
        uploadingVideo,
        openImagePicker,
        openImageCapturePicker,
        openVideoPicker,
        removeImage,
        removeVideo,
    } = useFeedbackAttachmentActions();

    const [showUploadSheet, setShowUploadSheet] = useState(false);

    const canShowAddButton = canUploadImages || canUploadVideo;
    const isUploading = uploadingImages || uploadingVideo;

    const handleAddClick = () => {
        if (isUploading) return;

        if (!imageAttachments.length && !hasVideo && canUploadImages && canUploadVideo) {
            setShowUploadSheet(true);
            return;
        }

        if (canUploadImages) {
            openImagePicker();
            return;
        }

        if (canUploadVideo) {
            openVideoPicker();
        }
    };

    const handleSelectImage = () => {
        setShowUploadSheet(false);
        openImagePicker();
    };

    const handleCaptureImage = () => {
        setShowUploadSheet(false);
        openImageCapturePicker();
    };

    const handleSelectVideo = () => {
        setShowUploadSheet(false);
        openVideoPicker();
    };

    return (
        <>
            <div className={styles.uploadSection}>
                <div className={styles.uploadList}>
                    {imageAttachments.map((item) => (
                        <div key={item.id} className={styles.uploadItem}>
                            <img src={item.url} alt="" className={styles.previewImage} />
                            <button
                                type="button"
                                className={styles.deleteBtn}
                                onClick={() => removeImage(item.id)}
                            >
                                <img src={setPostImage.delete} alt="删除" width={32} height={32} className={styles.delete}/>
                            </button>
                        </div>
                    ))}

                    {hasVideo && videoUrl && (
                        <div className={styles.uploadItem}>
                            <video src={videoUrl} className={styles.previewVideo} controls playsInline />
                            <button
                                type="button"
                                className={styles.deleteBtn}
                                onClick={removeVideo}
                            >
                                <img src={setPostImage.delete} alt="删除" width={32} height={32} className={styles.delete}/>
                            </button>
                        </div>
                    )}

                    {canShowAddButton && (
                        <button
                            type="button"
                            className={classNames(styles.uploadTrigger, isUploading && styles.uploadTriggerDisabled)}
                            onClick={handleAddClick}
                            disabled={isUploading}
                        >
                            {/* {isUploading ? (
                                <span className={styles.uploadingText}>上传中...</span>
                            ) : (
                                <span className={styles.plusIcon}>+</span>
                            )} */}
                        </button>
                    )}
                </div>
            </div>

            {showUploadSheet && (
                <div className={styles.sheetMask} onClick={() => setShowUploadSheet(false)}>
                    <div className={styles.sheetPanel} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.sheetGroup}>
                            <button type="button" className={styles.sheetItem} onClick={handleCaptureImage}>
                                拍摄
                            </button>
                            <button type="button" className={styles.sheetItem} onClick={handleSelectImage}>
                                上传图片
                            </button>
                            <button type="button" className={styles.sheetItem} onClick={handleSelectVideo}>
                                上传视频
                            </button>
                        </div>
                        <button
                            type="button"
                            className={classNames(styles.sheetItem, styles.sheetCancel)}
                            onClick={() => setShowUploadSheet(false)}
                        >
                            取消
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default observer(H5FeedbackAttachmentDisplay);
